import { fmt, type WallResult } from "@tasduvar/engine";
import { toSvg, type Transform } from "../geometry";

export function JointLevels({ t, result }: { t: Transform; result: WallResult }): JSX.Element {
  const g = result.geometry;
  return (
    <g>
      {result.joints.map((j) => {
        const y = toSvg(t, { x: 0, y: j.level }).y;
        const x1 = toSvg(t, { x: g.toe.x - 0.3, y: 0 }).x, x2 = toSvg(t, { x: g.heel.x + 0.3, y: 0 }).x;
        const ok = j.allOk;
        return (
          <g key={j.level} data-joint={j.level}>
            <line x1={x1} y1={y} x2={x2} y2={y} stroke={ok ? "#2E7D32" : "#C62828"} strokeDasharray="5 3" strokeWidth={1} />
            <text x={x2 + 4} y={y - 3} textAnchor="start" className="text-[10px] num" fill={ok ? "#2E7D32" : "#C62828"}>{ok ? "✓" : "✗"} y={fmt(j.level, 2)}</text>
          </g>
        );
      })}
    </g>
  );
}
